import { createContext, useContext } from "react";

/**
 * Scroll the next-level-up horizontal curriculum strip (e.g. Kukkiwon pattern row)
 * so its active tab stays visible. Nested providers may chain (e.g. JoHwa → Moo Gong Ryu).
 */
export const CurriculumParentStripNavSyncContext = createContext<(() => void) | null>(null);

export function useCurriculumParentStripNavSync(): (() => void) | null {
  return useContext(CurriculumParentStripNavSyncContext);
}
